import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=47f1d3e1&scoped=true&"
import script from "./DeliveryList.vue?vue&type=script&lang=js&"
export * from "./DeliveryList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=47f1d3e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1d3e1",
  null
  
)

export default component.exports